import React from 'react';
import ProductCard from '../card/ProductCard';
import { Box, useMediaQuery } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Grid, Navigation } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/navigation';
import "./style.css"

function Index(props) {
    const { giftCardData, fixSlideView } = props;
    const xsDevice = useMediaQuery("(max-width:600px)");
    const smDevice = useMediaQuery("(max-width:900px)");
    const mdDevice = useMediaQuery("(max-width:1200px)");
    const lgDevice = useMediaQuery("(max-width:1535px)");

    function handleSlideView() {
        let slideView;
        if (fixSlideView) {
            if (smDevice) {
                slideView = 3;
            } else if (mdDevice) {
                slideView = 4;
            } else if (lgDevice) {
                slideView = 5;
            } else {
                slideView = 5;
            }
        } else {
            if (xsDevice) {
                slideView = 2;
            } else if (smDevice) {
                slideView = 3;
            } else if (mdDevice) {
                slideView = 5;
            } else if (lgDevice) {
                slideView = 3;
            } else {
                slideView = 4;
            }
        }

        return slideView;
    }

    return (
        <Box sx={{
            height: {
                xs: 400,
                sm: 470,
                md: 470,
                lg: 500
            },
        }}>
            <Swiper
                slidesPerView={handleSlideView()}
                grid={{
                    rows: 2,
                }}
                spaceBetween={30}
                navigation={true}
                modules={[Grid, Navigation]}
                className="mySwiper"
            >
                {giftCardData?.map((item) => (
                    <SwiperSlide key={`gift-card-${item?.id}`}>
                        <ProductCard
                            customStyles={customStyles}
                            data={item}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    );
}
const customStyles = {
    minWidth: {
        xs: "170px",
        sm: "130px",
        md: "130px",
        lg: "110px",
    },
    maxWidth: {
        xs: "170px",
        sm: "195px",
        md: "180px",
        lg: "180px",
    },
    height: {
        xs: "190px",
        sm: "210px",
        md: "210px",
        lg: "210px",
        xl: "213px",
    },
    maxHeight: {
        xs: "190px",
        sm: "266px",
        md: "247px",
        lg: "260px",
        xl: "255px",
    },
    borderRadius: {
        xs: 6,
        sm: 4,
        lg: 5
    },
    boxShadow: {
        xs: 2,
        sm: "inset 0 0 10px #dee5eb",
        lg: 2
    },
    border: {
        xs: 0,
        sm: "3px solid #deebff"
    },
    p: { xl: "0 0 5px 0" },
    mx: { xs: "3px", sm: "3px" },
    my: {
        xs: "5px",
        sm: "3px",
        lg: "5px",
    },
    mb: {
        xs: "10px",
        sm: "3px",
        lg: "5px",
    },
    cardMedia: {
        p: 0,
        width: "100%",
        minHeight: { xs: 113, sm: 120, md: 120, lg: 115, xl: 115 },
        maxHeight: { xs: 151, sm: 122, md: 130, lg: 116, xl: 116 },
        borderRadius: "0 0 10px 10px",
        objectFit: {
            xs: "fill",
            sm: "cover",
            md: "contain",
            lg: "cover"
        },
        backgroundSize: {
            xs: "fill",
            sm: "cover",
            md: "contain",
            lg: "cover"
        },
        objectPosition: "50% 50%",
        mixBlendMode: "multiply"
    },
    ".product__discount": {
        width: "100%",
        p: "3px 0"
    },
    boughtUser: {
        fontSize: {
            xs: "10px",
            lg: "10px"
        },
        color: {
            xs: "textPrimary.main",
            lg: "textPrimary.main"
        },
        fontWeight: {
            xs: 400,
            lg: 400
        },
        display: {
            xs: "none",
            sm: "none"
        }
    },
    cardContent: {
        mt: "16px",
        py: { xs: 0 },
        px: {
            xs: "10px",
            sm: "15px"
        },
        height: {
            xs: "max-content",
            sm: "80px",
            md: "80px",
            lg: "65px",
        },
        overFlow: "hidden",
        webkitBoxOrient: "horizontal",
        webkitLineClamp: 2,
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        textAlign: {
            xs: "center",
            sm: "left",
            lg: "center"
        },
        mb: "5px",
    },
    title: {
        color: {
            xs: "primary.main",
            sm: "primary.main",
            lg: "primary.main"
        },
        fontSize: {
            xs: "14px",
            sm: "1.2rem",
            md: "1.2rem",
            lg: "1.2rem",
            xl: "14px",
        },
        fontWeight: { xs: 500, sm: 500, lg: 500, xl: 500 },
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        webkitLineClamp: 2,
        maxHeight: "3.6rem",
        lineHeight: { xs: "24px", md: "22px" },
        overflowWrap: "break-word",
        wordBreak: "normal",
        textAlign: "center"
    },
    button: {
        width: "100%",
        fontSize: {
            xs: "9px",
            sm: "10px",
            lg: "12px"
        },
        color: {
            xs: "white.main",
            sm: "white.main",
        },
        backgroundColor: {
            xs: "primary.main",
            sm: "primary.main",
        },
        textTransform: {
            xs: "capitalize"
        },
        borderRadius: {
            xs: 5,
            sm: 5,
            lg: 1
        }
    },
    cardActions: {
        px: 2,
        display: {
            xs: "none",
            sm: "none"
        },
        flexDirection: "column",
        alignItems: "flex-start",
        py: 0,
    },
}

export default Index